/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { PasscodeAccessiblePublicShareCard, JewelryAccessiblePublicShareCard } from './views/PublicShareCard/PublicShareCard.controller';
import { JewelryAccessiblePublicShareCardFile, PasscodeAccessiblePublicShareCardFile } from './views/PublicFile/PublicFile.controller';
import PublicRouteNames from './PublicRouteNames';
import LoadRequiredData from './LoadRequiredData';
import PolicyRoutes from './views/policies/PolicyRoutes';
import Unsubscribe from './views/Unsubscribe/Unsubscribe.redux';
import UnsubscribeSuccess from './views/Unsubscribe/UnsubscribeSuccess';

import Invalid from './views/PasscodeEntry/Invalid';
import SystemNotification from '../components/SystemNotification';

const PublicApp = () => (
  <LoadRequiredData>
    <SystemNotification />

    <Switch>
      <Route exact path="/policy/:languageCode/:documentName" component={PolicyRoutes} />
      <Route path="/policy" component={PolicyRoutes} />
      <Route path={PublicRouteNames.notFound()} component={Invalid} />
      <Route path={PublicRouteNames.unsubscribeSuccess()} component={UnsubscribeSuccess} />
      <Route path={PublicRouteNames.unsubscribe()} component={Unsubscribe} />
      <Route exact path={PublicRouteNames.publicMedicalJewelryShareCardFile()} component={JewelryAccessiblePublicShareCardFile} />
      <Route exact path={PublicRouteNames.publicFile()} component={PasscodeAccessiblePublicShareCardFile} />
      <Route exact path={PublicRouteNames.publicMedicalJewelryShareCard()} component={JewelryAccessiblePublicShareCard} />
      <Route path={PublicRouteNames.publicShareCard()} component={PasscodeAccessiblePublicShareCard} />
      <Redirect to={PublicRouteNames.notFound()} />
    </Switch>
  </LoadRequiredData>
);

export default PublicApp;
